import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

// EN | FR segmented toggle. The app's i18n has en/fr/nl, but the reviewers use EN/FR only, so this
// exposes just those two. Clicking switches i18next's active language for ALL texts and persists it
// (i18next caches the choice in localStorage under `addressval-language-fr-default` — see i18n.ts,
// which explains the key name and why French is the default). The active
// side is 'fr' when the resolved language starts with fr, else 'en'.
const LANGS = [
  { code: 'en', label: 'EN' },
  { code: 'fr', label: 'FR' },
] as const;

export function LanguageToggle() {
  const { i18n } = useTranslation();
  const active = (i18n.resolvedLanguage ?? i18n.language ?? 'en').startsWith('fr') ? 'fr' : 'en';

  return (
    <div
      className="inline-flex rounded-lg border border-slate-200 bg-white p-0.5"
      role="group"
      aria-label="Language / Langue"
    >
      {LANGS.map((l) => (
        <button
          key={l.code}
          type="button"
          onClick={() => i18n.changeLanguage(l.code)}
          aria-pressed={active === l.code}
          className={cn(
            'px-2.5 py-1 text-xs font-bold rounded-md transition-colors',
            active === l.code
              ? 'bg-brand-gradient text-white'
              : 'text-slate-500 hover:text-slate-800',
          )}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
